import './style.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.kjb-slider-image-wide__swiper');
    
    sliders.forEach((slider) => {
        const wrapper = slider.querySelector('.kjb-slider-image-wide__swiper-wrapper');
        const originalSlides = Array.from(wrapper.children);
        let slideCount = originalSlides.length;
        
        
        // スライドが6枚未満の場合、複製して6枚以上にする
        if (slideCount < 6) {
            const duplicatesNeeded = Math.ceil(6 / slideCount);
            for (let i = 1; i < duplicatesNeeded; i++) {
                originalSlides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });
            }
            slideCount = wrapper.children.length;
        }
        
        new Swiper(slider, {
            modules: [Navigation, Pagination],
            loop: true,
            initialSlide: 0,
            loopedSlides: slideCount,
            watchSlidesProgress: true,
            slidesPerView: 1.2,
            spaceBetween: 16,
            centeredSlides: true,
            navigation: {
                nextEl: '.kjb-slider-image-wide__button-next',
                prevEl: '.kjb-slider-image-wide__button-prev',
            },
            pagination: {
                el: '.kjb-slider-image-wide__pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                    slidesPerView: 1.4,
                },
                1024: {
                    spaceBetween: 40,
                    slidesPerView: 1.4,
                }
            }
        });
    });
});
